import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=18f1f60a&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=18f1f60a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f1f60a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18f1f60a')) {
      api.createRecord('18f1f60a', component.options)
    } else {
      api.reload('18f1f60a', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=18f1f60a&scoped=true&", function () {
      api.rerender('18f1f60a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22jpR9RB988h9/JS/comp/DateRangeExt.vue"
export default component.exports